export const tableColumnList = [
  // {
  //   field: 'originalAmount',
  //   title: '服务类型',
  //   editRender: {
  //     name: 'originalAmount',
  //   },
  // },
  {
    field: 'expenseType',
    title: '费用类型',
    editRender: { name: 'expenseType' },
  },
  {
    field: 'originalPrice',
    title: '结算单价（含税）',
    editRender: { name: 'originalPrice' },
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    editRender: {
      name: 'statementQuantity',
    },
  },

  {
    field: 'originalAmount',
    title: '结算金额(含税)',
    editRender: { name: 'originalAmount' },
  },

  {
    field: 'remark',
    title: '备注',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  expenseType: [{ required: true, message: '必填字段' }],
  originalPrice: [{ required: true, message: '必填字段' }],
  statementQuantity: [{ required: true, message: '必填字段' }],
  originalAmount: [{ required: true, message: '必填字段' }],
  currencyCode: [{ required: true, message: '必填字段' }],
  exchangeRate: [{ required: true, message: '必填字段' }],
  periodDateFrom: [{ required: true, message: '必填字段' }],
  periodDateUntil: [{ required: true, message: '必填字段' }],
  unit: [{ required: true, message: '必填字段' }],
  domesticAmount: [{ required: true, message: '必填字段' }],
};
